<template>
  <div class="index">
    <div style="margin-bottom: 10px">
      <el-breadcrumb slot="breadcrumb" class="breadcrumb-bg">
        <el-breadcrumb-item>首页</el-breadcrumb-item>
        <el-breadcrumb-item>菜单编辑</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <el-card>
        <el-form ref="form" :model="form" label-width="80px" :rules="rules" >
            <el-form-item label="名称" prop="title">
                <el-input v-model="form.title"></el-input>
            </el-form-item>

            <el-form-item label="菜单图标" >
                <el-input v-model="form.icons"></el-input>
            </el-form-item>
            <el-form-item label="组件(name)" prop="name">
                <el-input v-model="form.name"></el-input>
            </el-form-item>
            <el-form-item label="组件(path)" >
                <el-input v-model="form.path"></el-input>
            </el-form-item>
            <el-form-item label="组件" >
                <el-input v-model="form.component"></el-input>
            </el-form-item>


            <el-form-item label="上级菜单">
                <el-select v-model="form.pid" placeholder="上级菜单">
                    <el-option label="无" value="0"></el-option>
                    <el-option :label="item.title" :value="item.id" v-for="(item,index) in cate_data" :key="index"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="状态">
                <el-select v-model="form.state" placeholder="状态">
                    <el-option label="启用" value="1"></el-option>
                    <el-option label="禁用" value="0"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="是否认证">
                <el-select v-model="form.auth" placeholder="是否认证">
                    <el-option label="是" value="1"></el-option>
                    <el-option label="否" value="0"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="显示状态">
                <el-select v-model="form.isshow" placeholder="显示状态">
                    <el-option label="显示" value="1"></el-option>
                    <el-option label="隐藏" value="0"></el-option>
                </el-select>
            </el-form-item>
            <el-button @click="submitForm('form')" type="primary" >编辑</el-button>
        </el-form>
    </el-card>

  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  data() {
    return {

      cate_data:[],
      id:0,
      form: {
        title:"",
        name: "",
        pid:"",
        state:"",
        path:"",
        component:"",
        icons:"",
        isshow:"",
        auth:"",
        params:""

      },

      rules: {
          title: [
          {
            required: true,
            message: "请输入名称",
            trigger: "blur",
          },
          {  message: "请输入名称", trigger: "blur" },
        ],
      },

    };
  },
  methods: {
    ...mapActions({
        editMenuAction:"editMenuAction",
        getMenuIndexAction:"getMenuIndexAction"
    }),

    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.editMenuAction({
              type:1,
              title: this.form.title,
              name: this.form.name,
              path: this.form.path,

              state: this.form.state,
              pid: this.form.pid=='' ? 0 : this.form.pid,
              icons:this.form.icons,
              isshow:this.form.isshow,
              auth:this.form.auth,
              component:this.form.component,
              params:this.form.params,
              id:this.id


          });

            console.log("error submit!!");
        } else {

          console.log("error submit!!");
          return false;
        }
      });
    },
  },
  mounted() {
      this.getMenuIndexAction({ type:0})
      this.id=this.$route.params.id
     this.editMenuAction({type:0,id:this.id})
  },
    computed: {
    //   ...mapState({dataIndex:"index.dataIndex"}),
    ...mapState({
      result: (state) => state.menu.result,
    }),
  },
  watch: {
    result(val) {
      if (val.code == 303) {

          this.menu_data=val.data
          this.form.title=val.data.title
          this.form.name=val.data.name
          this.form.auth=val.data.requireAuth?"1":"0"
          this.form.state=val.data.state?"1":"0"
          this.form.icons=val.data.icons

          this.form.isshow=val.data.isshow

          this.form.component=val.data.component
          this.form.path=val.data.path

          if(val.data.pid=="0"){
              this.form.pid=''
          }else{

              this.form.pid=val.data.pid
          }



      }
        if (val.code == 304) {
            this.$message({
                message: "菜单更新成功",
                type: "success",
            });
            this.$router.push({name:"menu_index"})
        }
        if (val.code == 305) {
            this.$message({
                message: "菜单删除成功",
                type: "warning",
            });
        }
        if(val.code==200){
            this.cate_data=val.data

        }
        // this.form.name=""
        // this.form.state="1"
        // this.form.pid="0"
        // this.form.component=""
        // this.form.icons=""
        // this.form.path=""
        // this.form.title=""
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 120px;
  height: 120px;
  line-height: 120px;
  text-align: center;
}
.avatar {
  width: 120px;
  height: 120px;
  display: block;
}
</style>
